import React from 'react';
import PropTypes from 'prop-types';
import ReactLoading from 'react-loading';
import style from './style.scss';

export const Button = ({
  children = null,
  className = '',
  isDisabled = false,
  isLoading = false,
  onClick = () => {},
  ...rest
}) => (
  <button
    className={className}
    onClick={onClick}
    disabled={isDisabled || isLoading}
    {...rest}
  >
    {isLoading ? <div className={style.loadingWrapper}><ReactLoading width={24} height={24} /></div> : children}
  </button>
);

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default Button;
